import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/Subtopic1/GLB_FastFood_Sucio.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class FastFoodUnclean extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);

		this.nameMaterialChildrem = {
			Plane019: "Plane019",
			Plane019_1: "Plane019_1",
			Plane024: "Plane024",
			Plane024_1: "Plane024_1",
			Plane020: "Plane020",
			Plane020_1: "Plane020_1",
			Plane021: "Plane021",
			Plane021_1: "Plane021_1",
			Plane025: "Plane025",
			Plane025_1: "Plane025_1",
		}

		this.nameNotMaterial = {
			Gota_Cafe: {
				child: [this.nameMaterialChildrem.Plane019, this.nameMaterialChildrem.Plane019_1]
			},
			Mancha_cafe: {
				child: [this.nameMaterialChildrem.Plane024, this.nameMaterialChildrem.Plane024_1]
			},
			Manchas_Cafe_plancha: {
				child: [this.nameMaterialChildrem.Plane020, this.nameMaterialChildrem.Plane020_1]
			},
			Manchas_Gabinete: {
				child: [this.nameMaterialChildrem.Plane021, this.nameMaterialChildrem.Plane021_1]
			},
			Manchas_ketchup: {
				child: [this.nameMaterialChildrem.Plane025, this.nameMaterialChildrem.Plane025_1]
			},
		};

		this.gruopNameObjectsSelected = [
			{
				gruop: "ManchasCafe",
				childs: [
					...this.nameNotMaterial.Gota_Cafe.child,
					...this.nameNotMaterial.Mancha_cafe.child,
					...this.nameNotMaterial.Manchas_Cafe_plancha.child,
				],
				objects: [
					"Gota_Cafe",
					"Mancha_cafe",
					"Manchas_Cafe_plancha",
				]
			},
			{
				gruop: "ManchasBlancas",
				childs: [
					...this.nameNotMaterial.Manchas_Gabinete.child,
					"Manchas_suelo_02",
					"Manchas_Suelo_01"
				],
				objects: [
					"Manchas_Gabinete",
					"Manchas_suelo_02",
					"Manchas_Suelo_01",
				]
			},
			{
				gruop: "ManchasKatsup",
				childs: [
					...this.nameNotMaterial.Manchas_ketchup.child
				],
				objects: [
					"Manchas_ketchup",
				]
			},
			{
				gruop: "Maruchans",
				childs: [
					"Maruchan_3001",
					"Maruchan_3002",
					"Maruchan_2001",
				],
				objects: [
					"Maruchan_3001",
					"Maruchan_3002",
					"Maruchan_2001",
				]
			},
			{
				gruop: "Pinzas",
				childs: [
					"Pinzas"
				],
				objects: [
					"Pinzas"
				]
			},
		]

		this.addSelectObject = []

		this.animationsNormalManchas = null
		this.animationsNormal = null

		this.nameObjectMaterial = {
			floor: {
				objectColor: ["Plane021", "Plane021_1", "Manchas_Suelo_01", "Manchas_suelo_02"],
				objectEmissive: ["Maruchan_3002", "Maruchan_2001", "Maruchan_3001"],
			},
			sausages: {
				objectColor: ["Plane025", "Plane025_1"],
				objectEmissive: [],
			},
			vegetables: {
				objectColor: ["Plane020", "Plane020_1", "Plane024", "Plane024_1", "Plane019", "Plane019"],
				objectEmissive: ["Pinzas"],
			},
		}

	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Manchas_Suelo_01 = gltf.scene.getObjectByName("Manchas_Suelo_01", true);
			this.Maruchan_3001 = gltf.scene.getObjectByName("Maruchan_3001", true);
			this.Maruchan_3002 = gltf.scene.getObjectByName("Maruchan_3002", true);
			this.Maruchan_2001 = gltf.scene.getObjectByName("Maruchan_2001", true);
			this.Pinzas = gltf.scene.getObjectByName("Pinzas", true);
			this.Manchas_suelo_02 = gltf.scene.getObjectByName("Manchas_suelo_02", true);

			this.Gota_Cafe = gltf.scene.getObjectByName("Gota_Cafe", true);
			// Plane019,Plane019_1
			this.Mancha_cafe = gltf.scene.getObjectByName("Mancha_cafe", true);
			// Plane024,Plane024_1
			this.Manchas_Cafe_plancha = gltf.scene.getObjectByName("Manchas_Cafe_plancha", true);
			// Plane020,Plane020_1
			this.Manchas_Gabinete = gltf.scene.getObjectByName("Manchas_Gabinete", true);
			// Plane021, Plane021_1
			this.Manchas_ketchup = gltf.scene.getObjectByName("Manchas_ketchup", true);
			// Plane025, Plane025_1
			this.Bolsa_Basura = gltf.scene.getObjectByName("Bolsa_Basura", true);
			this.Bolsa_Basura.visible = false

			// this.onChangueEmissiveMaterial()

			this.onChangueSectionMaterial()
		});
	}

	onChangueSectionMaterial() {
		Object.values(this.nameObjectMaterial).forEach((namesObj) => {
			const { objectColor, objectEmissive } = namesObj
			if (objectColor.length > 0) {
				this.onChangueMaterialColor(objectColor)
			}
			if (objectEmissive.length > 0) {
				this.onChangueMaterialEmissive(objectEmissive)
			}
		})
	}

	onChangueMaterialColor(objs = []) {
		let materialglobal = null
		objs.forEach((obj, index) => {
			if (index === 0) {
				materialglobal = this.getObjectByName(obj, true).material.clone()
			}
			this.getObjectByName(obj, true).material = materialglobal
		})
	}
	onChangueMaterialEmissive(objs = []) {
		let materialglobal = null
		objs.forEach((obj, index) => {
			if (index === 0) {
				materialglobal = this.getObjectByName(obj, true).material.clone()
				materialglobal.emissive.set("#2E2E2E");
			}
			this.getObjectByName(obj, true).material = materialglobal
		})
	}
	onAnimationSectionName(name = "") {
		const selectObj = this.nameObjectMaterial[name]
		if (!selectObj) {
			return
		}
		const { objectColor, objectEmissive } = selectObj
		if (objectColor.length > 0) {
			this.onAnimateSelectColorName(objectColor[0])
		}
		if (objectEmissive.length > 0) {
			this.onAnimateSelectEmissiveName(objectEmissive[0])
		}
	}

	onAnimateSelectColorName(name = "") {
		const colorInicial = { color: "#ffffff" }; // Color blanco

		this.animationsNormalManchas = gsap.to(colorInicial, {
			color: "#474747",
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: 'power1.inOut',
			onUpdate: () => {
				this.getObjectByName(name, true).material.color.set(colorInicial.color)
			},
		});
	}

	onAnimateSelectEmissiveName(name = "") {
		this.animationsNormal = gsap.to(this.getObjectByName(name, true).material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: "power1.inOut",
		});
	}

	onChangueEmissiveMaterial() {
		const newMaterialEmissive = this.Maruchan_3001.material.clone();
		newMaterialEmissive.emissive.set("#2E2E2E");
		this.Maruchan_3001.material = newMaterialEmissive
		this.Maruchan_3002.material = newMaterialEmissive
		this.Maruchan_2001.material = newMaterialEmissive
		this.Pinzas.material = newMaterialEmissive
	}

	onInitActiv() {
		const objectChild = Object.values(this.gruopNameObjectsSelected)
		objectChild.forEach((obj) => {
			obj.objects.forEach((child) => {
				this[child].visible = true
			})
		})
		this.clearAnimation()
		this.addSelectObject = []
	}

	clearAnimation() {
		if (this.animationsNormalManchas) {
			this.animationsNormalManchas.kill()
			this.animationsNormalManchas = null
		}
		if (this.animationsNormal) {
			this.animationsNormal.kill()
			this.animationsNormal = null
		}
		this.onInitAnition()
	}

	onInitAnition() {
		this.onInitAnimationSectionName("floor")
		this.onInitAnimationSectionName("sausages")
		this.onInitAnimationSectionName("vegetables")
	}

	onInitAnimationSectionName(name = "") {
		const selectObj = this.nameObjectMaterial[name]
		if (!selectObj) {
			return
		}
		const { objectColor, objectEmissive } = selectObj
		if (objectColor.length > 0) {
			this.getObjectByName(objectColor[0], true).material.color.set("#fff")
		}
		if (objectEmissive.length > 0) {
			this.getObjectByName(objectEmissive[0], true).material.emissiveIntensity = 1
		}
	}

	onAnimateAll() {
		this.onAnimateColor()
		this.onAnimateEmissive()
	}

	onAnimateEmissive() {
		this.animationsNormal = gsap.to(this.Maruchan_3001.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: "power1.inOut",
		});
	}

	onAnimateColor(object) {
		// Define los colores inicial y final
		const colorInicial = { color: "#ffffff" }; // Color blanco

		// Configura la animación con TweenMax
		this.animationsNormalManchas = gsap.to(colorInicial, {
			color: "#474747",
			yoyo: true,
			repeat: -1,
			duration: 1,
			ease: 'power1.inOut',
			onUpdate: () => {
				this.Manchas_Suelo_01.material.color.set(colorInicial.color)
			},
		});
	}

	onEliminateScene(nameGroup = "") {
		const find = this.gruopNameObjectsSelected.find((g) => g.gruop === nameGroup)
		find.objects.forEach((obj) => {
			this[obj].visible = false
		})
	}

	onDetectObjectGroup(nameObject = "") {
		let selectName = ""
		for (let i = 0; i < this.gruopNameObjectsSelected.length; i++) {
			const element = this.gruopNameObjectsSelected[i];
			if (element.childs.includes(nameObject)) {
				selectName = element.gruop
				break;
			}
		}
		return selectName
	}

	onDetectObject(nameObject = "") {
		let selectName = ""
		for (let i = 0; i < this.gruopNameObjectsSelected.length; i++) {
			const element = this.gruopNameObjectsSelected[i];
			if (element.childs.includes(nameObject)) {
				selectName = element.gruop
				break;
			}
		}

		if (selectName === "") {
			return true
		}

		if (this.addSelectObject.includes(selectName)) {
			return true
		}

		this.onEliminateScene(selectName)
		this.addSelectObject.push(selectName)
		return false
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Comida rapida");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpersChild() {
		// this.helperMethod("Bolsa_Basura", this.Bolsa_Basura);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -200, 200).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -200, 200).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -200, 200).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
